module.exports = __webpack_public_path__ + "static/mascot_wave_burstless-66c848b5e83f0d4e7895503b03eef589.gif";